"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORK_ORDER_TEMPLATE_FIELDS = exports.RECURRENCE_RULE_FIELDS = exports.PROCURE_VENDOR_FIELDS = exports.PROCURE_VENDOR_CONTACT_FIELDS = exports.CONCIERGE_VENDOR_PROCURE_RATINGS_FIELDS = exports.CONCIERGE_VENDOR_CONCIERGE_RATINGS_FIELDS = exports.WORK_ORDER_COMMENT_FIELDS = exports.CONCIERGE_VENDOR_CONTACT_FIELDS = exports.CONCIERGE_VENDOR_ATTACHMENT_FIELDS = exports.CONCIERGE_VENDOR_FIELDS = exports.WORK_ORDER_BID_REQUEST_FIELDS = exports.CONCIERGE_WORK_ORDER_BID_FIELDS = exports.WORK_ORDER_BID_FIELDS = exports.WORK_ORDER_FIELDS = exports.ATTACHMENT_FIELDS = exports.WORK_ORDER_ISSUE_TYPE_FIELDS = exports.CONCIERGE_USER_FIELDS = exports.WORK_ORDER_STATUS_FIELDS = exports.WORK_ORDER_PRIORITY_FIELDS = exports.PROPERTY_FIELDS = exports.ASSET_FIELDS = exports.ORGANIZATION_ACCOUNT_FIELDS = void 0;
const client_1 = require("@apollo/client");
exports.ORGANIZATION_ACCOUNT_FIELDS = (0, client_1.gql) `
  fragment OrganizationAccountFields on OrganizationAccount {
    id
    name
    isTest
    safeleaseRelationshipId
    properties {
      id
      name
      fullAddress
    }
    users {
      id
      fullName
      userRole {
        id
        name
      }
      emailContactMethod {
        id
        value
      }
      phoneContactMethod {
        id
        value
      }
      profilePictureAttachment {
        id
        path
        fileType
        status
        url
      }
    }
  }
`;
exports.ASSET_FIELDS = (0, client_1.gql) `
  fragment AssetFields on Asset {
    id
    make
    model
    serialNumber
    manufactureDate
    manufactureDatePrecision
    purchaseDate
    status
    notes
    lotNumber
    location
    propertyId
    assetTypeId
    property {
      id
      name
    }
    attachments {
      id
      path
      fileType
      status
      url
      urlExpiresAt
    }
    assetType {
      id
      name
      issueTypeId
      issueType {
        id
        name
      }
    }
  }
`;
exports.PROPERTY_FIELDS = (0, client_1.gql) `
  ${exports.ASSET_FIELDS}
  fragment PropertyFields on Property {
    assets {
      ...AssetFields
    }
    id
    organizationAccountId
    name
    fullAddress
    address1
    address2
    city
    state
    zipcode
    latitude
    longitude
    createdByUserId
    updatedByUserId
  }
`;
exports.WORK_ORDER_PRIORITY_FIELDS = (0, client_1.gql) `
  fragment WorkOrderPriorityFields on WorkOrderPriority {
    id
    name
    description
  }
`;
exports.WORK_ORDER_STATUS_FIELDS = (0, client_1.gql) `
  fragment WorkOrderStatusFields on WorkOrderStatus {
    id
    name
    description
  }
`;
exports.CONCIERGE_USER_FIELDS = (0, client_1.gql) `
  fragment ConciergeUserFields on ConciergeUser {
    id
    userId
    firstName
    lastName
    fullName
  }
`;
exports.WORK_ORDER_ISSUE_TYPE_FIELDS = (0, client_1.gql) `
  fragment WorkOrderIssueTypeFields on IssueType {
    id
    name
    description
  }
`;
exports.ATTACHMENT_FIELDS = (0, client_1.gql) `
  fragment AttachmentFields on Attachment {
    id
    path
    fileType
    fileName
    displayName
    status
    url
    urlExpiresAt
    createdAt
    createdByUser {
      id
      firstName
      lastName
      fullName
    }
  }
`;
exports.WORK_ORDER_FIELDS = (0, client_1.gql) `
  fragment WorkOrderFields on WorkOrder {
    id
    title
    description
    propertyId
    dueDate
    propertyLocation
    conciergeEnabled
    conciergeLastEnabledAt
    conciergeLastDisabledAt
    completedAt
    creationStatus
    createdAt
    bidsRequested
    maxBudget
  }
`;
exports.WORK_ORDER_BID_FIELDS = (0, client_1.gql) `
  fragment WorkOrderBidFields on WorkOrderBid {
    id
    workOrderBidRequestId
    conciergeVendorId
    conciergeVendorContactId
    bidCostTotal
    materialsCostTotal
    laborCostTotal
    jobStartDate
    jobEndDate
    winningBid
    status
    acceptedAt
    declinedAt
    acceptedStatus
  }
`;
exports.CONCIERGE_WORK_ORDER_BID_FIELDS = (0, client_1.gql) `
  ${exports.WORK_ORDER_BID_FIELDS}
  fragment ConciergeWorkOrderBidFields on WorkOrderBid {
    ...WorkOrderBidFields
    publishedAt
    onsiteVisitDate
    notes
  }
`;
exports.WORK_ORDER_BID_REQUEST_FIELDS = (0, client_1.gql) `
  ${exports.WORK_ORDER_FIELDS}
  ${exports.CONCIERGE_USER_FIELDS}
  ${exports.ATTACHMENT_FIELDS}
  ${exports.WORK_ORDER_PRIORITY_FIELDS}
  ${exports.WORK_ORDER_STATUS_FIELDS}
  ${exports.WORK_ORDER_ISSUE_TYPE_FIELDS}
  ${exports.PROPERTY_FIELDS}
  ${exports.ORGANIZATION_ACCOUNT_FIELDS}
  fragment WorkOrderBidRequestFields on WorkOrderBidRequest {
    id
    status
    createdAt
    assignedConciergeUser {
      ...ConciergeUserFields
    }
    workOrder {
      ...WorkOrderFields
      workOrderPriority {
        ...WorkOrderPriorityFields
      }
      workOrderStatus {
        ...WorkOrderStatusFields
      }
      issueType {
        ...WorkOrderIssueTypeFields
      }
      property {
        ...PropertyFields
        organizationAccount {
          ...OrganizationAccountFields
        }
      }
      attachments {
        ...AttachmentFields
      }
    }
  }
`;
exports.CONCIERGE_VENDOR_FIELDS = (0, client_1.gql) `
  fragment ConciergeVendorFields on ConciergeVendor {
    id
    name
    description
    email
    phone
    status
    address1
    address2
    city
    state
    zipcode
    url
  }
`;
exports.CONCIERGE_VENDOR_ATTACHMENT_FIELDS = (0, client_1.gql) `
  ${exports.ATTACHMENT_FIELDS}
  fragment ConciergeVendorAttachmentFields on ConciergeVendor {
    contractAttachment {
      ...AttachmentFields
    }
    policyAttachment {
      ...AttachmentFields
    }
  }
`;
exports.CONCIERGE_VENDOR_CONTACT_FIELDS = (0, client_1.gql) `
  fragment ConciergeVendorContactFields on ConciergeVendorContact {
    id
    fullName
    role
    email
    phone
    phoneExtension
  }
`;
exports.WORK_ORDER_COMMENT_FIELDS = (0, client_1.gql) `
  fragment WorkOrderCommentFields on WorkOrderComment {
    id
    workOrderId
    content
    createdAt
    attachments {
      id
      path
      fileType
      status
      url
      urlExpiresAt
    }
    user {
      id
      firstName
      lastName
      fullName
      procureUser {
        userRole {
          id
          name
        }
        profilePictureAttachmentId
        profilePictureAttachment {
          id
          path
          fileType
          status
          url
          urlExpiresAt
        }
      }
    }
  }
`;
exports.CONCIERGE_VENDOR_CONCIERGE_RATINGS_FIELDS = (0, client_1.gql) `
  fragment ConciergeVendorConciergeRatingFields on ConciergeVendorConciergeRating {
    id
    conciergeVendorId
    workOrderBidRequestId
    speedRespondToEstimateRequest
    speedProvideEstimateFromRequestDate
    speedScheduleApprovedJob
    speedResponsivenessToProcure
    notes
  }
`;
exports.CONCIERGE_VENDOR_PROCURE_RATINGS_FIELDS = (0, client_1.gql) `
  fragment ConciergeVendorProcureRatingFields on ConciergeVendorProcureRating {
    id
    conciergeVendorId
    workOrderBidRequestId
    speedResponsivenessToPartner
    speedCompleteWorkOnceStarted
    qualityOfWork
    qualityOfInteractions
    notes
  }
`;
exports.PROCURE_VENDOR_CONTACT_FIELDS = (0, client_1.gql) `
  fragment ProcureVendorContactFields on ProcureVendorContact {
    id
    fullName
    role
    email
    phone
    phoneExtension
    notes
  }
`;
exports.PROCURE_VENDOR_FIELDS = (0, client_1.gql) `
  ${exports.PROCURE_VENDOR_CONTACT_FIELDS}
  ${exports.WORK_ORDER_ISSUE_TYPE_FIELDS}
  ${exports.PROPERTY_FIELDS}
  fragment ProcureVendorFields on ProcureVendor {
    id
    organizationAccountId
    name
    email
    phone
    address1
    address2
    city
    state
    zipcode
    procureVendorContacts {
      ...ProcureVendorContactFields
    }
    issueTypes {
      ...WorkOrderIssueTypeFields
    }
    properties {
      ...PropertyFields
    }
  }
`;
exports.RECURRENCE_RULE_FIELDS = (0, client_1.gql) `
  fragment RecurrenceRuleFields on RecurrenceRule {
    id
    frequency
    startDate
    interval
    weekStartDay
    count
    endDate
    bySetPosition
    byMonth
    byMonthDay
    byYearDay
    byWeekNumber
    byWeekDay
    lastOccurrenceDate
    nextOccurrenceDate
    lastProcessedAt
  }
`;
exports.WORK_ORDER_TEMPLATE_FIELDS = (0, client_1.gql) `
  ${exports.RECURRENCE_RULE_FIELDS}
  fragment WorkOrderTemplateFields on WorkOrderTemplate {
    id
    propertyId
    assignedUserId
    workOrderPriorityId
    issueId
    issueTypeId
    title
    description
    durationInDays
    propertyLocation
    conciergeEnabled
    bidsRequested
    maxBudget
    procureVendorId
    recurrenceRuleId
    recurrenceRule {
      ...RecurrenceRuleFields
    }
    createdByUserId
    createdAt
    deletedAt
    workOrderTemplateWatcherUsers {
      id
      userId
    }
  }
`;
//# sourceMappingURL=fragments.graphql.js.map